import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../navbar/navbar';
import './Gabby.css';
import { clear } from '@testing-library/user-event/dist/clear';
import { useTypewriter } from 'react-simple-typewriter';
function Gabby() {
    const [gabbyLoaderState, setGabbyLoaderState] = useState(false);
    const [contentLocked, setContentLocked] = useState(true);
    const [errorState, setErrorState] = useState(false);
    const [access, setAccess] = useState(false);
    const inputRef = useRef(null);
    const [msg, setMsg] = useState('');
    const [accessText] = useTypewriter({
        // The "","","","","","","","","", is needed, its a delay before typing.
        words: [`...`, ` `],
        loop: 3,
        delaySpeed: 100,
        typeSpeed: 500,
        deleteSpeed: 0,
        onLoopDone : ()=> setErrorState(true)
    });

    const iframeRef = useRef(null);
    useEffect(()=>{
        setTimeout(() => {
            console.log(inputRef.current)
            // setInterval(()=>{
            //     if(
            //         inputRef.current != null 
            //         && inputRef.current.value === process.env.REACT_APP_CODE
            //     ){
            //         console.log('oy blyat')
            //         setContentLocked(false);
            //     }
            // });
        }, 7800);
        setTimeout(() => {
            setAccess(true);
        }, 4500);
        if(!contentLocked){
            setTimeout(()=>{
                setGabbyLoaderState(true);
            }, 5100);
        }
        // const iframe = document.getElementById('iframe1');
        // const iframeDocument = iframe.contentWindow.document || iframe.contentDocument;
    },[]);
    useEffect(()=>{
        const interval = setInterval(()=>{
            if (iframeRef.current){
                console.log('exists');
                clearInterval(interval);
                const iframe = iframeRef.current;
                // const iframeDocument = iframe.contentWindow.document || iframe.contentDocument;
                // console.log(iframeDocument.style);
                
            } 
            else{
                // console.log('not exist');
            }
        });
    },[iframeRef.current])
    const checkAuth = (e) =>{
        // console.log(process.env.REACT_APP_CODE)
        if (e.value === process.env.REACT_APP_CODE){
            console.log('unlock')
            setGabbyLoaderState(true);
            setContentLocked(false);
            // setContentLocked(false);
        }
    };
    const setWAMessage = (e) =>{
        setMsg(e.value);
        console.log(msg);
        console.log(process.env.REACT_APP_PHONENUMBER)
    };
  return (
    <>
        <Navbar page="prettyelisa" linkstate={4000}></Navbar>
        { gabbyLoaderState && !contentLocked ? <>
              <div className="class" style={{ height: "100px" }}></div>
              <div className="class" style={{ height: "100px" }}></div>
              <div className="class" style={{ height: "20px" }}></div>

            <div className="gabby">
                <div className="Content">
                    <div className="leftsidebar">
                        <div className="GbE-title">
                            <h1>For you, love.</h1>
                        </div>
                        <div className="GbE-desc" style={{width:"90%", margin:"2px"}}>
                            <p>You may ask, why does this page exists? Because i miss you, i do. My memories with you are... Unforgettable. Those "sweeties", "darlings", and other couple callings... Gabby, forgive me. Can we start over yet?</p>
                        </div>
                        <div className="yes_or_no">
                            <h2 style={{textAlign:'right', margin:"30px"}}>Yes or No?</h2>
                        </div>
                        <div className="textarea">
                            <textarea name="" id="" cols="30" rows="8" style={{}} onChange={(e)=>{setWAMessage(e.target)}}></textarea>
                        </div>
                    <div className="btn">
                              <button onClick={() => { window.location.href = `https://api.whatsapp.com/send?phone=${process.env.REACT_APP_PHONENUMBER}&text=${msg}`}}>Sent via WhatsApp</button>
                    </div>
                    </div>
                    <div className="centerHeightDiv" style={{ backgroundColor:"gray", borderRadius:"100px"}}></div>
                    <div className="rightsidebar">
                    <div className="ttle">
                        <div className="textt">
                            <h1>Previous website that i made you, (2023):</h1>
                        </div>
                    </div>
                        <div className="iframes">
                            <iframe src="https://stepaltweb.tech/gabby"  id="iframe1"frameborder="0" ref={iframeRef} style={{}}></iframe>
                        </div>
                          {/* <br></br> */}
                          {/* <br></br> */}
                    </div>
                </div>
                {/* <br></br>
                <br></br>
            <br></br> */}
            </div>
            <div className="class" style={{height:"100px"}}></div>
            {/* DONE! */}
        </> : 
        <>
            <div className="contentLocked" style={{}}>
                  { access && <><h1>Accessing /prettyelisa{!errorState ? accessText : ''}</h1></>}
                {
                    errorState && <>
                    <div className="error"> 
                    
                    <h1>Failed, (Invalid Authentication Code)</h1>
                    <div className="accessContent">
                        <h2>Please retry with the new Auth code : </h2>
                        <input type="text" name="" id="" ref={inputRef} onChange={(e)=> checkAuth(e.target)} placeholder='Auth Code' />
                    </div>
                    </div>   
                    <h3><span id='star'>*</span>Content will load after You typed the correct Auth Code.</h3>
                    </>
                }
            </div>
        </>
        }
    </>
  )
}

export default Gabby;